import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const DamageCodeListGridColumns: Array<TableColumn> = [
  {
    id: 'damageCode',
    label: 'Damage Code',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue || '';
      },
    },
  },
  {
    id: 'description',
    label: 'Description',
    sortDisabled: true,
  },
  {
    id: 'damageType',
    label: 'Damage Type',
    dataType: {
      type: 'string',
      formatter: (value: any) => {
        const stringValue = (value ?? '') as string;
        return stringValue;
      },
    },
  },
  {
    id: 'actions',
    label: '',
    sortDisabled: true,
  },
];
